import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from '@/context/AuthContext';
import { DateFormatProvider } from '@/context/DateFormatContext';
import { Toaster } from '@/components/ui/toaster';

// Marketplace Pages
import MarketplacePage from '@/pages/MarketplacePage';
import MarketplacePropertyPage from '@/pages/MarketplacePropertyPage';
import MarketplaceAdminPage from '@/pages/MarketplaceAdminPage';
import GuestLoginPage from '@/pages/GuestLoginPage';
import GuestGoogleCallbackPage from '@/pages/GuestGoogleCallbackPage';

import '@/App.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <DateFormatProvider>
          <div className="min-h-screen bg-white">
            <Routes>
              {/* Public Marketplace Routes */}
              <Route path="/" element={<MarketplacePage />} />
              <Route path="/marketplace" element={<MarketplacePage />} />
              <Route path="/marketplace/property/:propertyId" element={<MarketplacePropertyPage />} />
              <Route path="/marketplace/login" element={<GuestLoginPage />} />
              <Route path="/marketplace/auth/google/callback" element={<GuestGoogleCallbackPage />} />

              {/* Admin Route */}
              <Route path="/admin/marketplace" element={<MarketplaceAdminPage />} />
            </Routes>
          </div>
          <Toaster />
        </DateFormatProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;